<template>
	<div>
		<el-divider>{{ keyword.kid ? '修改' : '添加' }}SEO优化词</el-divider>
		<el-form class="text-left" ref="typeForm" :rules="rules" :model="keyword" style="width: 80%;margin: 0 auto;">
			<el-form-item label="SEO优化词名称" :label-width="formLabelWidth" prop="keywordname">
				<el-input v-model="keyword.keywordname" autocomplete="off" placeholder="请输入SEO优化词名称,长度2-50个字符"></el-input>
			</el-form-item>
			<template v-if="!keyword.kid">
				<el-form-item v-for="(item,index) in keyword.words" :key="index" label="" :label-width="formLabelWidth" :prop="`words.${index}.keywordname`" :rules="rules.keywordname">
					<el-input v-model="item.keywordname" autocomplete="off" placeholder="请输入SEO优化词名称,长度2-50个字符" class="word-input"></el-input>
					<i class="el-icon-delete input-delete" @click="deleteWord(index)"></i>
				</el-form-item>
				<el-form-item label="" :label-width="formLabelWidth">
					<el-button size="mini" icon="el-icon-plus" type="warning" @click="addKey">批量添加</el-button>
				</el-form-item>
			</template>
			<el-form-item label="所属模型" :label-width="formLabelWidth" prop="mid">
				<el-select v-model="keyword.mid" placeholder="请选择模型">
					<el-option v-for="(item,index) in modelList" :key="index" :label="item.modelname" :value="item.mid"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="链接类型" :label-width="formLabelWidth">
				<el-radio v-model="keyword.islink" :label="1">外链</el-radio>
				<el-radio v-model="keyword.islink" :label="0">内链</el-radio>
			</el-form-item>
			<el-form-item v-if="keyword.islink" label="跳转网址" :label-width="formLabelWidth" prop="linkurl">
				<el-input v-model="keyword.linkurl" autocomplete="off" placeholder="请输入跳转网址,跳转网址前请务必加上http://"></el-input>
			</el-form-item>
		</el-form>
		<div style="margin-bottom: 15px;">
			<el-button type="primary" @click="submitForm('typeForm')">确定保存</el-button>
			<el-button type="default" @click="turnback">取消添加</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'addLink',
	data() {
		var linkurl = (rule,value,callback)=>{
			if(this.keyword.islink == 1){
				if(!value){
					callback(new Error('请输入链接地址'));
				}else{
					callback();
				}
			}
		};
		return {
			modelList:[],//模型列表
			keyword: {
				kid: '',
				mid:'',
				keywordname:'',
				words:[],
				islink:0,
				linkurl:'',//外部链接地址
			},
			extrawords:[],
			rules: {
				keywordname: [{ required: true, message: '请输入SEO优化词', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
				linkurl:[{validator:linkurl,trigger:'blur'}],
				mid: [{ required: true, message: '请选择所属模型', trigger: 'blur' }],
			},
			formLabelWidth: '130px',
			dialogImageUrl: '',
			dialogVisible: false
		};
	},
	mounted() {
		let query = this.$route.query;
		if(query.kid){
			this.keyword.kid = query.kid;
		}
		this.getModelList();
	},
	methods: {
		turnback(){
			this.$router.go(-1);
		},
		addKey(){
			this.keyword.words.push({
				keywordname:''
			});
		},
		deleteWord(i){
			this.keyword.words.splice(i,1);
		},
		getModelList(){
			this.$axios({
				url: this.HOST + '/admin.seo/getModelList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.modelList = res.data; 
						if(this.$route.query.kid){
							this.getKeywordInfo(this.$route.query.kid);
						}
					}
				})
				.catch(err => {});
		},
		getKeywordInfo(kid){
			this.$axios({
				url: this.HOST + '/admin.seo/getKeywordInfo',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					kid:kid
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.keyword = res.data; 
					}
				})
				.catch(err => {});
		},
		submitForm(ruleform) {
			console.log(this.keyword);
			this.$refs[ruleform].validate((valid, attr) => {
				if (valid) {
					this.addKeyword();
				} else {
					console.log('error submit!!', attr);
					return false;
				}
			});
		},
		addKeyword() {
			this.$axios({
				url: this.HOST + '/admin.seo/addKeyword',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					keyword: this.keyword
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.$router.go(-1);
					}
				})
				.catch(err => {});
		},
	}
};
</script>
<style lang="scss">
.el-button + .el-button-group {
	margin-left: 10px;
	margin-right: 10px;
}
.el-form-item {
	margin-bottom: 20px;
}
.el-alert {
	display: inline;
	.el-alert__content {
		line-height: 20px;
	}
}
.word-input{
	width: calc(100% - 40px);
}
.input-delete.el-icon-delete{
	width: 20px;
	height: 20px;
	box-sizing: border-box;
	font-size: 20px;
	margin-top: 10px;
	margin-left: 10px;
	&:hover{
		color: #458efc;
		cursor: pointer;
	}
}
</style>
